import {
  Accordion,
  AccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  Typography,
  withStyles,
} from '@material-ui/core';
import { ContentWrapperWidget, MainTemplate } from '../../components/layouts';
import React, { ChangeEvent, FC, useState } from 'react';

import ContactInfo from '../../components/widgets/User/ContactInfo';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MainInfo from '../../components/widgets/User/MainInfo';
import { blue } from '@material-ui/core/colors';
import onExpand from '../../utils/onExpand';
import { usePermission } from '../../hooks/usePermission';
import { useRouteMatch } from 'react-router-dom';
import { useUserQuery } from '../../api';

enum AccordionTypes {
  MainInfo = 'MainInfo',
  ContactInfo = 'ContactInfo',
}

const AccordionSummary = withStyles({
  root: {
    backgroundColor: blue[700],
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    color: 'white',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary) as any;

// @TODO: Update View for Dialog request to Archive

const Single: FC<{}> = () => {
  const {
    params: { id },
  } = useRouteMatch();
  // const [page, setPage] = useState<number>(0);
  const [expanded, setExpanded] = useState<AccordionTypes | undefined>(AccordionTypes.MainInfo);

  const access = usePermission('users');
  // const style = useStyle();
  // const canAdd = true;
  const { data } = useUserQuery({ skip: !id || id === 'new', variables: { id } });
  const handleChangeAccordion = (panel: AccordionTypes) => (event: ChangeEvent<{}>, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : undefined);
  };

  return (
    <MainTemplate
      pageName=""
      url=""
      title={id === 'new' ? 'Добавить нового пользователя' : `Пользователь: ${data?.user?.email}`}
    >
      <ContentWrapperWidget>
        {id === 'new' ? (
          <h2>Добавить нового пользователя</h2>
        ) : (
          <h2>
            Пользователь: {data?.user?.name} {data?.user?.email}
          </h2>
        )}
        <Accordion
          expanded={expanded === AccordionTypes.MainInfo}
          onChange={handleChangeAccordion(AccordionTypes.MainInfo)}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Общая информация</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {onExpand(expanded, AccordionTypes.MainInfo) && (
              <MainInfo id={data?.user?.id || 'new'} readonly={!access.includes(2)} />
            )}
          </AccordionDetails>
        </Accordion>
        <Accordion
          disabled={id === 'new'}
          expanded={expanded === AccordionTypes.ContactInfo}
          onChange={handleChangeAccordion(AccordionTypes.ContactInfo)}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Контактная информация</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {onExpand(expanded, AccordionTypes.ContactInfo) && <ContactInfo id={id} readonly={!access.includes(2)} />}
          </AccordionDetails>
        </Accordion>
      </ContentWrapperWidget>
    </MainTemplate>
  );
};

export default Single;
